export { default } from './BenefitsSlider';
